import { errorToast } from '@core/utils/toast'
import axios from 'axios'
import { useLoading } from 'vue-loading-overlay'
import router from '../router'
import { userRefresh } from './config/apiRoute'

export const VITE_API_URL = `${import.meta.env.VITE_API_URL}`
export const VITE_API_URL_PROTOCOLS = `${import.meta.env.VITE_API_URL_PROTOCOLS}`

const api = axios.create({
  baseURL: VITE_API_URL
})

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (
      error.response.status === 401 &&
      error.response?.data &&
      error.response?.data.detail.toLowerCase().includes('expired token')
    ) {
      const originalRequest = error.response.config
      originalRequest._retry = true

      const refreshToken = localStorage.getItem('refreshToken')
      try {
        const response = await axios.post(
          `${VITE_API_URL}${userRefresh}`,
          {
            token: refreshToken
          },
          {
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
              Authorization: `Bearer ${refreshToken}`,
              'Accept-Language': 'es'
            }
          }
        )

        const { data } = response
        if (data.access_token) {
          localStorage.setItem('accessToken', data.access_token)
          originalRequest.headers.Authorization = `Bearer ${data.access_token}`

          if (originalRequest.url.includes('logout')) {
            const originalData = JSON.parse(originalRequest.data)
            originalData.access_token = data.data.access_token
            originalRequest.data = JSON.stringify(originalData)
          }

          return axios(originalRequest)
        }

        clearLocalStorage()
      } catch (e) {
        /**
         * if refresh token expired go to Login pages
         */
        if (
          e.response.status === 401 &&
          e.response?.data &&
          e.response?.data.detail.toLowerCase().includes('expired refresh')
        ) {
          errorToast(e.response?.data.detail)
          clearLocalStorage()
        }
      }
    } else {
      // TODO check resolve mesagge
      let msg = ''
      if (error.response?.data?.detail?.error?.message) msg = null
      else if (error.response?.data && typeof error.response?.data === 'string')
        msg = error.response?.data
      else if (error.response?.data.detail && typeof error.response?.data.detail === 'string')
        msg = error.response?.data.detail
      else if (Array.isArray(error.response?.data.detail)) {
        msg = error.response?.data.detail.map((e) => `${e.msg} - ${e.loc.at(1)}`).join(', ')
      } else if (typeof error.response?.data.detail === 'object') {
        msg = decodeURIComponent(error.response?.data.detail.error_description)
      }

      if (msg && error.response?.status !== 404) {
        errorToast(msg)
      }
    }

    return Promise.reject(error)
  }
)

function clearLocalStorage() {
  localStorage.removeItem('accessToken')
  localStorage.removeItem('refreshToken')

  router.push({ name: 'login' })
}

export const apiHttp = async (method, endpoint, data, options = {}, loading = true) => {
  const $loading = useLoading()
  const accessToken = localStorage.getItem('accessToken')
  const defaultHeaders = {
    Accept: 'application/json',
    Authorization: `Bearer ${accessToken}`,
    'Accept-Language': 'es'
  }

  if (!(data instanceof FormData)) {
    defaultHeaders['Content-Type'] = 'application/json'
  }

  options.headers = {
    ...defaultHeaders,
    ...(options.headers || {})
  }

  // eslint-disable-next-line no-prototype-builtins
  if (method === 'GET' && !options.hasOwnProperty('params')) {
    // eslint-disable-next-line no-param-reassign
    options.params = data
  }

  let serviceResponse = {}
  method = method.toLowerCase()
  const servicePromise = api({
    method,
    url: `${endpoint}`,
    data,
    ...options
  })
  let loader = null
  if (loading) loader = $loading.show({ color: '#FFA400' })
  try {
    const [materializedPromise] = await Promise.all([servicePromise])
    serviceResponse = { ...materializedPromise }
  } catch (error) {
    serviceResponse = error.response
  } finally {
    if (loader) loader.hide()
  }

  return serviceResponse
}
